var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
    [
      _c("el-table-column", {
        attrs: { prop: "date", label: "赠品编码", width: "180" },
      }),
      _c("el-table-column", {
        attrs: { prop: "name", label: "赠品名称", width: "180" },
      }),
      _c("el-table-column", { attrs: { prop: "address", label: "赠品数量" } }),
      _c("el-table-column", { attrs: { prop: "address", label: "赠品图片" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }